export default __webpack_public_path__ + "static/media/dana.8f604253.jpg";